var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextileOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "styler_24dp_FILL0_wght200_GRAD0_opsz24",
    d: "M167.5-804v-11.346h-3.893a3.461,3.461,0,0,1-2.555-1.064A3.538,3.538,0,0,1,160-818.994a3.758,3.758,0,0,1,.589-2.038,3.555,3.555,0,0,1,1.581-1.383L175-828.138v-2.492a4.618,4.618,0,0,1-2.708-1.637,4.541,4.541,0,0,1-1.061-2.964,4.608,4.608,0,0,1,1.385-3.378A4.574,4.574,0,0,1,175.982-840a4.548,4.548,0,0,1,3.364,1.4,4.621,4.621,0,0,1,1.385,3.365h-2.077a2.742,2.742,0,0,0-.763-1.973A2.514,2.514,0,0,0,176-838a2.679,2.679,0,0,0-1.973.8,2.68,2.68,0,0,0-.8,1.973,2.681,2.681,0,0,0,.8,1.974,2.679,2.679,0,0,0,1.973.8.968.968,0,0,1,.712.287.968.968,0,0,1,.288.713v3.323l12.792,5.723a3.755,3.755,0,0,1,1.6,1.383,3.617,3.617,0,0,1,.609,2.026,3.544,3.544,0,0,1-1.064,2.588,3.5,3.5,0,0,1-2.582,1.073H184.5V-804Zm-3.893-13.346H167.5v-1.885h17v1.885h3.854a1.581,1.581,0,0,0,1.171-.481,1.624,1.624,0,0,0,.475-1.188,1.81,1.81,0,0,0-.24-.906,1.511,1.511,0,0,0-.721-.641L176-826.369l-13,5.807a1.618,1.618,0,0,0-.74.641,1.709,1.709,0,0,0-.26.906,1.668,1.668,0,0,0,.452,1.188A1.517,1.517,0,0,0,163.607-817.346ZM169.5-806h13v-11.231h-13Zm0-11.231h0Z",
    transform: "translate(-160 840)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextileOthers);
export default __webpack_public_path__ + "static/media/textileOthers.d9058fcc3e518586f6e78b8ffc9070b0.svg";
export { ForwardRef as ReactComponent };